import React, { useEffect, useState } from 'react';
import Checkbox from 'shared/inputs/BaseCheckbox';
import Select from 'shared/inputs/BaseSelect';
import FieldsToSelectDropdown from './components/FieldsToSelectDropdown';
// Helpers
import { has } from 'lodash';

const EnumFilter = ({
  filter, fieldsNameForSearch = [], onFilterChange, data, collection, fieldInfo,
}) => {
  const { value } = filter;
  const displayItem = data.find((x) => x.value === value || x.value === value?.value);
  const [displayValue, setDisplayValue] = useState(displayItem);
  const [compareWithOtherFieldDisplayValue, setCompareWithOtherFieldDisplayValue] = useState(
    filter.compareWithOtherField ? value : null,
  );
  const [compareWithOtherField, setCompareWithOtherField] = useState(filter.compareWithOtherField);

  const onChange = (event) => {
    const newFilter = {
      ...filter,
      value: event.target.value.value,
      fieldMetadata: {
        collection,
      },
      fieldInfo,
    };

    delete newFilter.compareWithOtherField;

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setDisplayValue(event.target.value);
  };

  useEffect(() => {
    setCompareWithOtherField(filter.compareWithOtherField);
  }, [filter.compareWithOtherField]);

  useEffect(() => {
    const setValue = filter.compareWithOtherField ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(value);
  }, [value]);

  useEffect(() => {
    if (!has(filter, 'fieldInfo')) {
      onFilterChange.call(undefined, {
        nextFilter: {
          ...filter,
          fieldInfo,
        },
      });
    }
  }, []);

  const handleFieldToCompareChanged = (event) => {
    const value = event.target.value.field;

    const newFilter = {
      ...filter,
      value,
      compareWithOtherField: true,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setCompareWithOtherFieldDisplayValue(event.target.value);
  };

  const handleCompareWithOtherFields = ({ value }) => {
    const newFilter = value ? {
      ...filter,
      value: typeof compareWithOtherFieldDisplayValue === 'object'
        ? compareWithOtherFieldDisplayValue?.field : compareWithOtherFieldDisplayValue,
      compareWithOtherField: true,
      fieldInfo,
    } : {
      field: filter.field,
      operator: filter.operator,
      value: typeof displayValue === 'object' ? displayValue?.value : displayValue,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    const setValue = !value ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(null);
    setCompareWithOtherField(value);
  };

  return (
    <div className='app-filters-input'>
      {compareWithOtherField && fieldsNameForSearch.length > 0
        ? (
          <FieldsToSelectDropdown
            fields={fieldsNameForSearch}
            onFieldChanged={handleFieldToCompareChanged}
            value={compareWithOtherFieldDisplayValue}
          />
        ) : (
          filter.operator !== 'isnull' && filter.operator !== 'isnotnull'
        )
          && (
            <Select
              onChange={onChange}
              data={data}
              dataItemKey='value'
              textField='description'
              value={displayValue}
            />
          )}
      {fieldsNameForSearch.length > 0 && (
        <div className='filter-cbx-wrapper'>
          <Checkbox
            value={compareWithOtherField}
            label='Compare with other field'
            onChange={handleCompareWithOtherFields}
          />
        </div>
      )}
    </div>
  );
};

export default EnumFilter;
